import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
  OnInit,
} from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogConfig, MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DialogService } from 'src/app/core/dialogs/dialog.service';
import { ProfileService } from '../providers';

export const TYPE = 'competitiveDisclaimer';

@Component({
  selector: 'app-competitive-disclaimer-dialog',
  styleUrls: ['./competitive-disclaimer-dialog.component.scss'],
  template: `
    <h2 mat-dialog-title>
      {{ 'main.disclaimers.competitive.title' | translate }}
    </h2>
    <mat-dialog-content>
      <p>
        {{ 'main.disclaimers.competitive.body' | translate }}
      </p>
    </mat-dialog-content>
    @if (!isSettingsView()) {
      <mat-dialog-actions align="center">
        <button mat-flat-button (click)="onAccept()" id="accept-button">
          {{ 'main.disclaimers.competitive.accept_button' | translate }}
        </button>
        <button mat-button (click)="onDecline()" id="decline-button">
          {{ 'main.disclaimers.competitive.decline_button' | translate }}
        </button>
      </mat-dialog-actions>
    }
    @if (isSettingsView()) {
      <mat-dialog-actions align="center">
        <button mat-button (click)="onClose()" id="accept-button">OK</button>
      </mat-dialog-actions>
    }
  `,
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CompetitiveDisclaimerDialogComponent implements OnInit {
  readonly service = inject(DialogService);
  readonly profileService = inject(ProfileService);
  readonly router = inject(Router);
  readonly isAccepted = signal(false);
  readonly isSettingsView = signal(false);

  ngOnInit(): void {
    const url = this.router.url;
    if (url.includes('settings')) {
      this.isSettingsView.set(true);
    }
    const config = new MatDialogConfig();
    config.disableClose = true;
    config.autoFocus = '#accept-button';
    this.service.registerDialog(
      TYPE,
      CompetitiveDisclaimerDialogComponent,
      config
    );
  }

  async onAccept(): Promise<void> {
    try {
      await this.profileService.acceptCompetitiveDisclaimer();
      this.isAccepted.set(true);
      this.close();
    } catch (error) {
      console.error(
        'competitive-disclaimer-dialog.component.onAccept  error:',
        error
      );
    }
  }

  onDecline(): void {
    this.router.navigate(['signout']);
  }

  onClose(): void {
    this.close();
  }

  show(): void {
    this.service.openDialog(TYPE);
  }

  close(): void {
    this.service.closeDialog(TYPE);
  }
}
